import React from "react";
import "./custom2.css";

//Preventing right-click > save Image (I know they can just do printScreen, but that is in low res)
//document.addEventListener('contextmenu', event => event.preventDefault());

function Custom3() {
    return(
        <a className="customContainer" href="/custom4">
            <div className="liliesBorder">
                <img src="./images/liliesBorder.jpg" className="liliesBorderImage" alt="Decoration" />
            </div>
            <div className="slideContainer" id="slide2">
                <div className="stepContainer">
                    <span className="stepBox"></span>
                    <span className="stepText">
                        Photo Choice
                    </span>
                    <span className="arrowFloat">
                        <img className="rightArrow" src="./images/misc/arrowright2.gif" alt="cue to click for next slide."></img>
                    </span>
                </div>
            </div>
            <div className="instructions">
                <div className="instructionText">
                    A photo showing more complexity will add expense. For example, the one showing the top of the boat requires many more pieces to be cut than the one that does not show the top of the boat.
                </div>
                <img className="instructionImage" src="./images/commission/detailAngle.png" alt="Examples of high image detail and low image detail."></img>
            </div>
        </a>
    );
};


export default Custom3